import { render } from 'preact';
import { EmlakDanismanlariApp } from '../modules/emlakDanismanlari/EmlakDanismanlariApp.jsx';
import '../styles/emlak-danismanlari.css';

const root = document.getElementById('pp-emlak-danismanlari-root');

if (root) {
  render(
    <EmlakDanismanlariApp
      apiUrl={root.dataset.apiUrl || '/accounts/emlak-danismanlari/api/'}
      citiesUrl={root.dataset.citiesUrl || '/api/cities/'}
      townsUrl={root.dataset.townsUrl || '/api/towns/'}
      quartersUrl={root.dataset.quartersUrl || '/api/quarters/'}
    />,
    root,
  );
}
